/**
 * Rede de segurança para fotos de avatar: se a imagem falhar (arquivo apagado no S3, link antigo),
 * troca pelas iniciais em vez do ícone de imagem quebrada. Vale para toda a SPA, sem mexer em cada tela.
 */
const AVATAR_SRC = /\/media\/avatars\/|\/avatars\/|X-Amz-Signature/i;

function initials(name: string): string {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '';
    const first = parts[0][0] ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] ?? '' : '';
    return (first + last).toUpperCase();
}

function placeholder(name: string): string {
    const text = initials(name);
    const body = text
        ? `<text x="50" y="50" dy=".35em" text-anchor="middle" font-family="Inter,Arial,sans-serif" font-size="38" font-weight="700" fill="#5b5b5b">${text}</text>`
        : '<circle cx="50" cy="38" r="16" fill="#a1a1aa"/><path d="M18 86c4-18 18-26 32-26s28 8 32 26" fill="#a1a1aa"/>';
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="#e9e3d3"/>${body}</svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export function installAvatarFallback(): void {
    document.addEventListener(
        'error',
        (event) => {
            const img = event.target;
            if (!(img instanceof HTMLImageElement) || img.dataset.avatarFallback === '1') return;
            if (!AVATAR_SRC.test(img.currentSrc || img.src)) return;

            img.dataset.avatarFallback = '1';
            img.src = placeholder(img.alt || img.title || '');
        },
        true,
    );
}
